export const CREDIT_TYPES_INDEX_TOUR = {
  id: "credit_types_index",
  steps: [
    {
      element: '[data-tour="credit-types-create"]',
      popover: {
        title: "Novo tipo de crédito",
        description:
          "Tipos de crédito são globais da conta e ficam disponíveis para uso em qualquer plano.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="credit-types-list"]',
      popover: {
        title: "Tipos cadastrados",
        description: "Chave, label e unidade de cada tipo de crédito.",
        side: "top",
      },
    },
  ],
};
